export const imageUrlToFile = async (
	url: string,
	filename: string,
	mimeType: string,
) => {
	const response = await fetch(url, {
		cache: 'no-cache',
	})
	if (response.status >= 400) {
		throw new Error('Failed to fetch image', { cause: response.statusText })
	}
	const blob = await response.blob()
	return new File([blob], filename, { type: mimeType })
}
